<template>
  <!-- 添加自有物品弹窗 -->
  <div>
    <div v-if="selectedPrize" class="prize-item" @click="visiblePrize = true">
      <img :src="selectedPrize.image" alt />
      <p>
        <span>{{ selectedPrize.name }}</span>
      </p>
      <p>
        <span>{{ selectedPrize.second_name }}</span>
      </p>
      <p>
        <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
          getRank(selectedPrize.rank)
        }}</span>
        <span class="price">${{ selectedPrize.price }}</span>
      </p>
    </div>
    <div v-else class="add-prize" @click="visiblePrize = true">
      <i class="el-icon-plus"></i>
      <p>选择奖品</p>
    </div>
    <!-- 奖品列表 -->
    <el-dialog append-to-body :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
      <el-row style="margin-bottom: 20px">
        <el-input style="width: 200px; margin-right: 20px" placeholder="奖品名称搜索" v-model="query.name"></el-input>
        <el-button type="primary" @click="getPrize">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i class="el-icon-plus" title="添加" @click="handleAddPrize(item)"></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span v-if="item.darkgoldenrod === 1">暗金：普通"</span>
              <span v-if="item.darkgoldenrod === 2">暗金：StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 3">暗金：★StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 4">暗金：★"</span>
              <span v-if="item.darkgoldenrod === 5">暗金：纪念品"</span>
            </p>
            <p :style="`color: ${getRankColor(item.rank)};`">{{
            getRank(item.rank)
            }}</p>
            <p class="price">${{ item.price }}</p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination background :page-size="prizeListMeta.per_page || 15" :total="prizeListMeta.total || 0"
        :current-page="prizeListMeta.current_page" @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
import rank from '../../utils/ranks'
import quality from '../../utils/quality'

export default {
  props: {
    value: {//数据
      type: Object,
      default: undefined
    },
    prizeInfo: {//奖品信息
      type: Object,
      default: undefined
    },
    typeNum: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visiblePrize: false,//奖品列表显示标志
      loading: false,//加载动画
      loadingPrize: false,//加载物品列表的动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      prizeList: undefined,//奖品列表
      query: {//奖品搜索
        page: 1,
        name: undefined,
      },
      selectedPrize: undefined,//选择的奖品信息
      prizeListMeta: undefined,//奖品列表的底部分页
      staticData: {
        rank: rank,
        quality: quality,
      },
      taskRules: {//任务表单验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogInfo: {
      get() {
        return this.prizeInfo
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeNum
      },
      set() {
      }
    },
  },
  watch: {
    dialogInfo: {
      handler(newVal, oldVal) {
        this.selectedPrize = newVal
      },
      immediate: true,
      deep: true
    },
    visiblePrize(val) {
      //监听物品列表弹窗显示
      if (val) {
        this.getPrize()
      }
    }
  },
  created() {
  },
  methods: {
    handleAddPrize(row) {
      //选择奖品并赋值
      this.selectedPrize = row
      this.visiblePrize = false
      this.$emit("selectedData", row)
    },
    getPrize() {
      //查询奖品
      this.loadingPrize = true
      let params = this.query
      getData(`prize`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handlePrizePageChange(page) {
      //奖品列表点击底部分页
      this.query.page = page
      this.getPrize()
    },
    getRank(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>

</style>